import { fetch } from 'containers/ClanManagement/proxy/helpers'

export const CRAFT_MACHINE_INFO_REQUEST = 'craft_machine/INFO_REQUEST'
export const CRAFT_MACHINE_INFO_SUCCESS = 'craft_machine/INFO_SUCCESS'
export const CRAFT_MACHINE_INFO_ERROR = 'craft_machine/INFO_ERROR'

export function requestCraftMachineInfo() {
    return async (dispatch, getState) => {
        dispatch({ type: CRAFT_MACHINE_INFO_REQUEST })

        const { gatewayHost } = getState().settings
        const url = `${gatewayHost}/craft/clan_landing/` // trailing slash is mandatory

        // mock:
        if (process.env.API_ENV === 'mock') {
            const craftMachineResponse = require('../__mocks__/clan_landing_mock').craft_machine_response
            const isCraftServiceEnabled = (
                craftMachineResponse.is_craft_machine_enabled ||
                craftMachineResponse.is_enhancements_enabled
            )
            return dispatch({
                type: CRAFT_MACHINE_INFO_SUCCESS,
                payload: {
                    ...craftMachineResponse,
                    is_craft_service_enabled: isCraftServiceEnabled,
                },
            })
        }

        try {
            // TODO: refactor and use vanilla fetch
            const response = await fetch(url, { credentials: 'include' })
            const isCraftServiceEnabled = (response.is_craft_machine_enabled || response.is_enhancements_enabled)
            dispatch({
                type: CRAFT_MACHINE_INFO_SUCCESS,
                payload: {
                    ...response,
                    is_craft_service_enabled: isCraftServiceEnabled,
                },
            })
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('>> WGSH cannot request craft machine info', e)
            dispatch({
                type: CRAFT_MACHINE_INFO_ERROR,
            })
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/craft_machine.js